import React, { useEffect, useState } from 'react';
import DashboardFooter from '../components/DashboardFooter';
import { Quantum } from 'ldrs/react';

const Transactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedTxId, setExpandedTxId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [dateFilter, setDateFilter] = useState('');

    useEffect(() => {
        const fetchTransactions = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await fetch(`${process.env.REACT_APP_HOST_API_URL}/admin-user/transactions/`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const data = await response.json();
                setTransactions(data.data);
            } catch (err) {
                console.log(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTransactions();
    }, []);

    const filteredTransactions = transactions.filter(tx => {
        const matchesSearch =
            (tx.reference_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(tx.user_mobile || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (tx.user_email || '').toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = statusFilter === 'all' || tx.status === statusFilter;

        const matchesDate =
            !dateFilter || new Date(tx.created_at).toISOString().split('T')[0] === dateFilter;

        return matchesSearch && matchesStatus && matchesDate;
    });

    const toggleExpand = (id) => {
        setExpandedTxId(expandedTxId === id ? null : id);
    };

    if (loading) return (
        <>
            <div className="d-flex justify-content-center align-items-center " style={{
                minHeight: 'calc(100vh - 40px)',
                width: '100vw',
                marginLeft: '-280px',
                padding: '20px'
            }}>
                <Quantum
                    size="45"
                    speed="1.75"
                    color="blue"
                />
            </div>
        </>
    );


    return (
        <div
            className="d-flex flex-column min-vh-100 pb-2 px-3"
            style={{ backgroundColor: '#f8f9fa' }}
        >
            {/* Main Content Wrapper */}
            <div className="flex-grow-1">

                <div className="container-fluid  px-2 px-md-4" style={{ paddingTop: '20px' }}>
                    {/* Page Heading */}
                    <div className="row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded"
                        style={{ zIndex: 1050, background: "linear-gradient(135deg, #0564bf, #89CFF0)" }}>
                        <div className="col-12">
                            <h3 className="text-light mb-1">Transactions</h3>
                        </div>
                        <p className="text-light mb-0">
                            View and track all financial transactions within the system.

                        </p>
                        <div className="d-flex justify-content-between align-items-center  flex-wrap mt-3" style={{ gap: '0.75rem' }}>
                            <div className='d-flex gap-4'>

                                <input
                                    type="date"
                                    className="form-control"
                                    style={{ maxWidth: '180px' }}
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                />
                                <input
                                    style={{
                                        minWidth: '260px',
                                        border: 'none',
                                        outline: 'none',
                                        padding: '6px 10px',
                                        borderRadius: '6px',
                                        backgroundColor: 'white',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                    }}
                                    type="search"
                                    placeholder="Search by name, email, or mobile"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div>
                                <select
                                    className="form-select"
                                    style={{ maxWidth: '140px' }}
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="all">All Status</option>
                                    <option value="succeeded">Succeeded</option>
                                    <option value="failed">Failed</option>
                                    <option value="pending">Pending</option>
                                </select>
                            </div>

                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive shadow-sm rounded bg-white mt-5 mb-3">
                        <table className="table mb-0 align-middle">
                            <thead className="table-light">
                                <tr className='px-2'>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Reference No</th>
                                    <th>Status</th>
                                    <th> Received Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTransactions.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-3 text-muted">
                                            No transactions found.
                                        </td>
                                    </tr>
                                ) : (
                                    filteredTransactions.map(tx => (
                                        <React.Fragment key={tx.id}>
                                            {/* Main row */}
                                            <tr
                                                style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                                                onClick={() => toggleExpand(tx.id)}
                                                className="table-row-hover"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse-${tx.id}`}
                                                aria-expanded={expandedTxId === tx.id ? "true" : "false"}
                                                aria-controls={`collapse-${tx.id}`}
                                            >
                                                <td>


                                                    {tx.created_at
                                                        ? new Intl.DateTimeFormat('en-GB', {
                                                            day: 'numeric',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).format(new Date(tx.created_at))
                                                        : '-'}
                                                </td>


                                                <td>{tx.user_username}</td>
                                                <td>{tx.reference_number}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${tx.status === "failed"
                                                            ? "text-danger"
                                                            : tx.status === "pending"
                                                                ? "text-warning"
                                                                : "text-success"
                                                            }`}
                                                    >
                                                        {tx.status.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td className="d-flex align-items-center justify-content-between">

                                                    <span className="fw-bold text-primary">${tx.amount !== null ? Number(tx.amount).toFixed(2) : '0.00'}</span>
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            transition: 'transform 0.3s',
                                                            transform: expandedTxId === tx.id ? 'rotate(90deg)' : 'rotate(0deg)',
                                                            marginRight: '40px'
                                                        }}
                                                    >
                                                        <img
                                                            src="https://img.icons8.com/?size=100&id=33619&format=png&color=228BE6"
                                                            alt="expand"
                                                            width="20"
                                                            height="20"
                                                        />
                                                    </span>
                                                </td>

                                            </tr>

                                            {/* Expanded collapse row */}
                                            <tr>
                                                <td colSpan="5" className="p-0">

                                                    <div className={`collapse ${expandedTxId === tx.id ? 'show' : ''}`} id={`collapse-${tx.id}`}>
                                                        <div className='p-3 mx-2 my-2 rounded shadow-sm'
                                                            style={{
                                                                background:
                                                                    "linear-gradient(135deg, #f8fbff, #e9f3ff)",
                                                                borderLeft: "5px solid #0d6efd",
                                                                animation: "fadeIn 0.4s ease-in-out",
                                                            }}>
                                                            <div className="" >
                                                                {/* Details */}
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>📱 Mobile: </strong> {tx.user_mobile}</p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>✉️ Email: </strong> {tx.user_email}</p></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>💳 Payment Method: </strong><span className="badge bg-info ms-2">{tx.payment_method}</span></p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>🆔 Request ID: </strong><span className="text-muted">{tx.payment_request_id}</span></p></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>💰 Refund Amount: </strong><span className="text-success">   {tx.refunded_amount !== null ? Number(tx.refunded_amount).toFixed(2) : '0.00'}</span></p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>🧾 All Inclusive Fee: </strong><span className="text-primary">{tx.all_inclusive_fee ? Number(tx.all_inclusive_fee).toFixed(2) : '0.00'} </span></p></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>🔖 Discount Fee: </strong><span className="text-warning">{tx.discount_fee !== null ? Number(tx.discount_fee).toFixed(2) : '0.00'}</span></p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>⚙️ Fixed Fee: </strong><span className="text-secondary">{tx.fixed_fee !== null ? Number(tx.fixed_fee).toFixed(2) : '0.00'}</span></p></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>🧾 Tax: </strong><span className="text-danger">{tx.tax !== null ? Number(tx.tax).toFixed(2) : '0.00'}</span></p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>🏁 Net Amount: </strong><span className="badge bg-success px-2">{tx.final_amount !== null ? Number(tx.final_amount).toFixed(2) : '0.00'}</span></p></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6"><p className="mb-1"><strong>📅 Last Updated Date: </strong><span className="text-info"> {tx.updated_at ? tx.updated_at.split('T')[0] : '-'}</span></p></div>
                                                                    <div className="col-md-6"><p className="mb-1"><strong>⏱️ Last Updated Time: </strong><span className="text-info ">{tx.updated_at ? tx.updated_at.split('T')[1] : '-'}</span></p></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
            <DashboardFooter />
        </div>
    );
};

export default Transactions;
